import * as auth from './auth';
import * as user from './user';
import * as application from './application';
import * as notebooks from './notebooks';
import * as datasets from './datasets';
import * as kernel from './kernel';

export default { auth, user, application, kernel, notebooks, datasets };
